import React, { Component } from "react";
import Input from "../inputs/input";
import InputLoading from "../inputs/input-loading";
import Select from "../selects/select";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import PhoneUtils from "../../shared/utils/PhoneUtils";
import CepUtils from "../../shared/utils/CepUtils";
import EmailUtils from "../../shared/utils/EmailUtils";

const TIPOS_PARTICIPANTE_LEGADOS = {
  OTICA_PRODUTORA: "Ótica Produtora",
  "OTICA PRODUTORA": "Ótica Produtora",
};

class FormularioEmpresa extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingCep: false,
    };

    this.cepTimeoutRef = null;
    this.telefoneRef = React.createRef();
    this.celularRef = React.createRef();
    this.firstInputRef = React.createRef();
  }

  focusFirstField = () => {
    if (this.firstInputRef.current) {
      const input = this.firstInputRef.current.querySelector("input");
      if (input) {
        input.focus();
      }
    }
  }

  componentWillUnmount() {
    if (this.cepTimeoutRef) {
      clearTimeout(this.cepTimeoutRef);
    }
  }

  handleChange = async (e) => {
    const { name, value } = e.target;
    let cleanedValue = value;

    if (name === "cnpj") {
      cleanedValue = CnpjUtils.cleanCnpj(value);
    } else if (name === "emailEmpresa") {
      cleanedValue = EmailUtils.formatEmail(value);
    } else if (name === "celular" || name === "telefone" || name === "dddCelular" || name === "dddTelefone") {
      cleanedValue = PhoneUtils.cleanPhone(value);
    } else if (name === "cep") {
      cleanedValue = PhoneUtils.cleanPhone(value);

      if (this.cepTimeoutRef) {
        clearTimeout(this.cepTimeoutRef);
        this.cepTimeoutRef = null;
      }

      if (cleanedValue.length === 8 && !this.props.readOnlyFields?.includes("cep")) {
        if (e.target && e.target.classList) {
          e.target.classList.remove("has-error");
        }

        this.cepTimeoutRef = setTimeout(async () => {
          this.setState({ loadingCep: true });

          const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error('Timeout')), 5000);
          });

          try {
            const endereco = await Promise.race([
              CepUtils.buscarEndereco(cleanedValue),
              timeoutPromise
            ]);

            if (endereco && this.props.onUpdateMultiple) {
              const camposAtualizados = {
                cep: CepUtils.formatCep(cleanedValue),
                logradouro: endereco.logradouro || "",
                bairro: endereco.bairro || "",
                cidade: endereco.cidade || "",
                estado: endereco.estado || ""
              };

              this.props.onUpdateMultiple(camposAtualizados);
            }
          } catch (error) {
            console.warn("Erro ao buscar CEP:", error);
          } finally {
            this.setState({ loadingCep: false });
          }
        }, 150);
      } else {
        this.setState({ loadingCep: false });
      }
    }

    if (this.props.onChange) {
      this.props.onChange(name, cleanedValue);
    }

    if (name === "dddTelefone" && cleanedValue.length === 2) {
      setTimeout(() => {
        if (this.telefoneRef.current) {
          const input = this.telefoneRef.current.querySelector("input");
          if (input) input.focus();
        }
      }, 50);
    } else if (name === "dddCelular" && cleanedValue.length === 2) {
      setTimeout(() => {
        if (this.celularRef.current) {
          const input = this.celularRef.current.querySelector("input");
          if (input) input.focus();
        }
      }, 50);
    }
  };

  handleFocus = (e, fieldName) => {
    const { name } = e.target;

    if (this.isReadOnly(name)) {
      return;
    }

    const currentValue = this.props.values[name] || '';

    if (name === 'cep' && currentValue) {
      const formatted = CepUtils.formatCep(currentValue);
      if (formatted !== currentValue && this.props.onChange) {
        this.props.onChange(name, formatted);
      }
    } else if (name === 'cnpj' && currentValue) {
      const formatted = CnpjUtils.formatCnpj(currentValue);
      if (formatted !== currentValue && this.props.onChange) {
        this.props.onChange(name, formatted);
      }
    } else if ((name === 'telefone' || name === 'celular') && currentValue) {
      const formatted = PhoneUtils.formatPhone(currentValue);
      if (formatted !== currentValue && formatted !== currentValue.replace(/[^0-9]/g, '') && this.props.onChange) {
        this.props.onChange(name, formatted);
      }
    }

    if (e.target && e.target.classList) {
      e.target.classList.remove("has-error");
    }
  };

  isReadOnly = (fieldName) => {
    return this.props.readOnly === true || (this.props.readOnlyFields && this.props.readOnlyFields.includes(fieldName));
  };

  render() {
    const { values = {}, errors = {}, showLabels = true } = this.props;
    const readOnlyFields = this.props.readOnlyFields || [];

    const camposObrigatorios = [
      'tipoParticipante', 'razaoSocial', 'nomeFantasia', 'cep', 'logradouro',
      'numero', 'bairro', 'estado', 'cidade', 'emailEmpresa', 'dddCelular', 'celular'
    ];

    const tiposParticipante = [
      { label: "Ótica", value: "OTICA" },
      { label: "Laboratório", value: "LABORATORIO" },
    ];
    const tipoAtual = values.tipoParticipante;
    if (this.isReadOnly("tipoParticipante") && tipoAtual && !tiposParticipante.some(item => item.value === tipoAtual)) {
      tiposParticipante.push({ label: TIPOS_PARTICIPANTE_LEGADOS[tipoAtual] || tipoAtual, value: tipoAtual });
    }

    return (
      <div>
        {showLabels && (
          <>
            <h2 className="signup-right__next-account--title">Cadastro da Empresa</h2>
            <p className="signup-right__next-account--warning">* Campos obrigatórios</p>
          </>
        )}

        <div className="row">
          <div className="col-12 col-md-6" ref={this.firstInputRef}>
            <Input
              name="cnpj"
              id="cnpj"
              label={camposObrigatorios.includes("cnpj") ? "CNPJ*" : "CNPJ"}
              type="text"
              width="100%"
              mask={[/[A-Za-z0-9]/, /[A-Za-z0-9]/, ".", /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, ".", /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, "/", /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, "-", /\d/, /\d/]}
              pipe={value => value.toUpperCase()}
              value={values.cnpj || ""}
              onChange={(e) => this.handleChange(e)}
              onFocus={e => this.handleFocus(e, 'cnpj')}
              readOnly={this.isReadOnly("cnpj")}
              required={camposObrigatorios.includes("cnpj") && !this.isReadOnly("cnpj")}
            />
            <span className="field-error-message" style={{ visibility: errors.cnpj ? "visible" : "hidden" }}>
              {errors.cnpj || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Select
              label={camposObrigatorios.includes("tipoParticipante") ? "Tipo de Participante*" : "Tipo de Participante"}
              width="100%"
              className="tipoParticipante"
              name="tipoParticipante"
              aria="Selecione o tipo de participante"
              itens={tiposParticipante}
              value={values.tipoParticipante || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              required={camposObrigatorios.includes("tipoParticipante") && !this.isReadOnly("tipoParticipante")}
              disabled={this.isReadOnly("tipoParticipante")}
            />
            <span className="field-error-message" style={{ visibility: errors.tipoParticipante ? "visible" : "hidden" }}>
              {errors.tipoParticipante || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <Input
              name="razaoSocial"
              id="razaoSocial"
              label="Razão Social*"
              type="text"
              width="100%"
              value={values.razaoSocial || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("razaoSocial")}
              required={!this.isReadOnly("razaoSocial")}
            />
            <span className="field-error-message" style={{ visibility: errors.razaoSocial ? "visible" : "hidden" }}>
              {errors.razaoSocial || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Input
              name="nomeFantasia"
              id="nomeFantasia"
              label="Nome Fantasia*"
              type="text"
              width="100%"
              value={values.nomeFantasia || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("nomeFantasia")}
              required={!this.isReadOnly("nomeFantasia")}
            />
            <span className="field-error-message" style={{ visibility: errors.nomeFantasia ? "visible" : "hidden" }}>
              {errors.nomeFantasia || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <Input
              name="cep"
              id="cep"
              label="CEP*"
              type="text"
              width="100%"
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
              value={values.cep || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'cep')}
              readOnly={this.isReadOnly("cep")}
              required={!this.isReadOnly("cep")}
            />
            <span className="field-error-message" style={{ visibility: errors.cep ? "visible" : "hidden" }}>
              {errors.cep || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6" style={{ position: "relative" }}>
            <Input
              name="logradouro"
              id="logradouro"
              label="Logradouro*"
              type="text"
              width="100%"
              value={values.logradouro || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("logradouro")}
              required={!this.isReadOnly("logradouro")}
              disabled={this.state.loadingCep}
            />
            <InputLoading show={this.state.loadingCep} />
            <span className="field-error-message" style={{ visibility: errors.logradouro ? "visible" : "hidden" }}>
              {errors.logradouro || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <Input
              name="numero"
              id="numero"
              label="Número*"
              type="text"
              width="100%"
              value={values.numero || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("numero")}
              required={!this.isReadOnly("numero")}
            />
            <span className="field-error-message" style={{ visibility: errors.numero ? "visible" : "hidden" }}>
              {errors.numero || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Input
              name="complemento"
              id="complemento"
              label="Complemento"
              type="text"
              width="100%"
              value={values.complemento || ""}
              onChange={this.handleChange}
              readOnly={this.isReadOnly("complemento")}
            />
            <span className="field-error-message" style={{ visibility: "hidden" }}>&nbsp;</span>
          </div>
          <div className="col-12 col-md-6" style={{ position: "relative" }}>
            <Input
              name="bairro"
              id="bairro"
              label="Bairro*"
              type="text"
              width="100%"
              value={values.bairro || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("bairro")}
              required={!this.isReadOnly("bairro")}
              disabled={this.state.loadingCep}
            />
            <InputLoading show={this.state.loadingCep} />
            <span className="field-error-message" style={{ visibility: errors.bairro ? "visible" : "hidden" }}>
              {errors.bairro || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Input
              name="pontoReferencia"
              id="pontoReferencia"
              label="Ponto de Referência"
              type="text"
              width="100%"
              value={values.pontoReferencia || ""}
              onChange={this.handleChange}
              readOnly={this.isReadOnly("pontoReferencia")}
            />
            <span className="field-error-message" style={{ visibility: "hidden" }}>&nbsp;</span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6" style={{ position: "relative" }}>
            <Input
              name="estado"
              id="estado"
              label="Estado*"
              type="text"
              width="100%"
              value={values.estado || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("estado")}
              required={!this.isReadOnly("estado")}
              disabled={this.state.loadingCep}
            />
            <InputLoading show={this.state.loadingCep} />
            <span className="field-error-message" style={{ visibility: errors.estado ? "visible" : "hidden" }}>
              {errors.estado || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6" style={{ position: "relative" }}>
            <Input
              name="cidade"
              id="cidade"
              label="Cidade*"
              type="text"
              width="100%"
              value={values.cidade || ""}
              onChange={this.handleChange}
              onFocus={e => e.target.classList.remove("has-error")}
              readOnly={this.isReadOnly("cidade")}
              required={!this.isReadOnly("cidade")}
              disabled={this.state.loadingCep}
            />
            <InputLoading show={this.state.loadingCep} />
            <span className="field-error-message" style={{ visibility: errors.cidade ? "visible" : "hidden" }}>
              {errors.cidade || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-2">
            <Input
              name="dddTelefone"
              id="dddTelefone"
              label="DDD"
              type="text"
              mask={[/\d/, /\d/]}
              width="100%"
              value={values.dddTelefone || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'dddTelefone')}
              maxLength={2}
              readOnly={this.isReadOnly("dddTelefone")}
            />
            <span className="field-error-message" style={{ visibility: errors.dddTelefone ? "visible" : "hidden" }}>
              {errors.dddTelefone || ""}
            </span>
          </div>
          <div className="col-12 col-md-4" ref={this.telefoneRef}>
            <Input
              name="telefone"
              id="telefone"
              label="Telefone de Trabalho"
              type="text"
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
              width="100%"
              value={values.telefone || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'telefone')}
              maxLength={10}
              readOnly={this.isReadOnly("telefone")}
            />
            <span className="field-error-message" style={{ visibility: errors.telefone ? "visible" : "hidden" }}>
              {errors.telefone || ""}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Input
              name="emailEmpresa"
              id="emailEmpresa"
              label="Email da Empresa*"
              type="email"
              width="100%"
              value={values.emailEmpresa || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'emailEmpresa')}
              readOnly={this.isReadOnly("emailEmpresa")}
              required={!this.isReadOnly("emailEmpresa")}
            />
            <span className="field-error-message" style={{ visibility: errors.emailEmpresa ? "visible" : "hidden" }}>
              {errors.emailEmpresa || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-2">
            <Input
              name="dddCelular"
              id="dddCelular"
              label="DDD*"
              type="text"
              mask={[/\d/, /\d/]}
              width="100%"
              value={values.dddCelular || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'dddCelular')}
              maxLength={2}
              readOnly={this.isReadOnly("dddCelular")}
              required={!this.isReadOnly("dddCelular")}
            />
            <span className="field-error-message" style={{ visibility: errors.dddCelular ? "visible" : "hidden" }}>
              {errors.dddCelular || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-4" ref={this.celularRef}>
            <Input
              name="celular"
              id="celular"
              label="Celular*"
              type="text"
              width="100%"
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
              value={values.celular || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'celular')}
              maxLength={10}
              readOnly={this.isReadOnly("celular")}
              required={!this.isReadOnly("celular")}
            />
            <span className="field-error-message" style={{ visibility: errors.celular ? "visible" : "hidden" }}>
              {errors.celular || "Campo obrigatório"}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default FormularioEmpresa;
